/**
 * Token Manager - Singleton class to manage authentication tokens in memory
 * 
 * This stores:
 * - authToken: The JWT access token (stored in memory, cleared on refresh)
 * - userId: The authenticated user's ID
 * - userRole: The user's role (admin, user, etc.)
 * 
 * Refresh token is stored as HttpOnly cookie by the backend
 */
class TokenManager {
  constructor() {
    if (TokenManager.instance) {
      return TokenManager.instance;
    }
    
    this.authToken = null;
    this.userId = null;
    this.userRole = null;
    
    TokenManager.instance = this;
  }

  /**
   * Set the authentication token
   * @param {string|null} token - JWT access token
   */
  setAuthToken(token) {
    this.authToken = token;
  }

  /**
   * Get the authentication token
   * @returns {string|null} JWT access token
   */
  getAuthToken() {
    return this.authToken;
  }

  /**
   * Set the user ID
   * @param {string|null} userId - User ID
   */
  setUserId(userId) {
    this.userId = userId;
  }

  /**
   * Get the user ID
   * @returns {string|null} User ID
   */
  getUserId() {
    return this.userId;
  }

  /**
   * Set the user role
   * @param {string|null} role - User role
   */
  setUserRole(role) {
    this.userRole = role;
  }

  /**
   * Get the user role
   * @returns {string|null} User role
   */
  getUserRole() {
    return this.userRole;
  }

  /**
   * Clear all stored tokens and user data
   */
  clear() {
    this.authToken = null;
    this.userId = null;
    this.userRole = null;
  }

  /**
   * Check if user is authenticated
   * @returns {boolean} True if user has a valid token
   */
  isAuthenticated() {
    return this.authToken !== null && this.authToken !== '';
  }
}

// Create and export singleton instance
const tokenManager = new TokenManager();

export default tokenManager;
